import create from 'zustand';
import { parseISO } from 'date-fns';
import { InstallationTime, InstallationTimeCodes, NullableAddressLookup, NullableDate } from '../types';
import { ReduxDevTools } from '../helpers/storeLogger';
import { StatePersistence } from '../helpers/storePersister';
import { sessionStorage } from '../helpers/sessionStorage';

const sessionStorageStateName = 'Upgradable Box Installation Store';
const getSessionStorageState = (): IUpgradableBoxesStore => {
  const state = JSON.parse(sessionStorage.getItem(sessionStorageStateName) ?? '{}', (key, value) => {
    const dateKeys = ['installationDate'];
    // if its not a date don't worry about it
    if (!dateKeys.includes(key)) return value;
    // otherwise parse the ISO string
    return parseISO(value);
  });
  return state;
};

export interface IUpgradableBoxesStore {
  mainContactAvailability: string,
  alternateName: string;
  alternateAreaCode: string;
  alternatePhoneNumber: string;
  dogs: string;
  techNotes: string;
  areaCode: string;
  phoneNumber: string;
  serviceAddress: NullableAddressLookup;
  installationDate: NullableDate;
  installationTime: InstallationTime;
  isValid: boolean;
  boxInstallRequired: boolean;
  slots: boolean;
  currentAddress: string;
  fullName: string;
  ownership: string;
}

const InitialState: IUpgradableBoxesStore = {
  mainContactAvailability: '',
  alternateName: '',
  alternateAreaCode: '',
  alternatePhoneNumber: '',
  dogs: '',
  techNotes: '',
  areaCode: '',
  phoneNumber: '',
  serviceAddress: null,
  installationDate: null,
  installationTime: InstallationTimeCodes.AM,
  isValid: true,
  boxInstallRequired: false,
  slots: false,
  currentAddress: '',
  fullName: '',
  ownership: '',
};

interface UpgradableBoxesStore {
  details: IUpgradableBoxesStore;
  errorAvailableDates: boolean;
  setDetails: (value: IUpgradableBoxesStore) => void;
  setErrorAvailableDates: (value: boolean) => void;
  clearDetails: () => void;
}

const [useUpgradableBoxesStore, upgradableBoxesStoreApi] = create<UpgradableBoxesStore>(
  ReduxDevTools(
    StatePersistence(
      set => ({
        details: InitialState,
        errorAvailableDates: false,
        ...getSessionStorageState(),
        setDetails: (value: IUpgradableBoxesStore) => {
          set({ details: value }, 'set upgradable box details');
        },
        setErrorAvailableDates: (value: boolean) => {
          set({ errorAvailableDates: value }, 'set error Technician Available Dates');
        },
        clearDetails: () => {
          set(
            { details: InitialState, errorAvailableDates: false },
            'reset upgradable box installation store'
          );
        },
      }),
      sessionStorageStateName
    ),
    'Upgradable Box Installation Details'
  )
);

export { useUpgradableBoxesStore, upgradableBoxesStoreApi };
